import type { ToastRootProps } from "reka-ui";
import type { HTMLAttributes } from "vue";

export { default as Toast } from "./Toast.vue";
export { default as ToastAction } from "./ToastAction.vue";
export { default as ToastClose } from "./ToastClose.vue";
export { default as ToastDescription } from "./ToastDescription.vue";
export { default as Toaster } from "./Toaster.vue";
export { default as ToastProvider } from "./ToastProvider.vue";
export { default as ToastTitle } from "./ToastTitle.vue";
export { default as ToastViewport } from "./ToastViewport.vue";
export { toast, useToast } from "./use-toast";

import { cva, type VariantProps } from "class-variance-authority";

export const toastVariants = cva(
	"tw:group tw:pointer-events-auto tw:relative tw:flex tw:w-full tw:items-center tw:justify-between tw:space-x-4 tw:overflow-hidden tw:rounded-md tw:border tw:border-slate-200 tw:p-6 tw:pr-8 tw:shadow-lg tw:transition-all tw:data-[swipe=cancel]:translate-x-0 tw:data-[swipe=end]:translate-x-[--radix-toast-swipe-end-x] tw:data-[swipe=move]:translate-x-[--radix-toast-swipe-move-x] tw:data-[swipe=move]:transition-none tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[swipe=end]:animate-out tw:data-[state=closed]:fade-out-80 tw:data-[state=closed]:slide-out-to-right-full tw:data-[state=open]:slide-in-from-top-full tw:data-[state=open]:sm:slide-in-from-bottom-full tw:dark:border-slate-800",
	{
		variants: {
			variant: {
				default:
					"tw:border tw:bg-white tw:text-slate-950 tw:dark:bg-slate-950 tw:dark:text-slate-50",
				destructive:
					"tw:destructive tw:group tw:border-red-500 tw:bg-red-500 tw:text-slate-50 tw:dark:border-red-900 tw:dark:bg-red-900 tw:dark:text-slate-50",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

type ToastVariants = VariantProps<typeof toastVariants>;

export interface ToastProps extends ToastRootProps {
	class?: HTMLAttributes["class"];
	variant?: ToastVariants["variant"];
	onOpenChange?: ((value: boolean) => void) | undefined;
}
